import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
} from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Plot from "react-plotly.js";

export const ProfilingResultView = ({ results }) => {
  const [currentRowCount, setCurrentRowCount] = useState("");
  const [graphOpen, setGraphOpen] = useState(false);
  const [graphColumn, setGraphColumn] = useState(null);
  useEffect(() => {
    setCurrentRowCount(results[0]?.count);
  }, []);

  const SimpleStatCard = ({ title, value, color = "#1E88E5" }) => (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        padding: 3,
        width: "200px",
        height: "120px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border: "1px solid #d3d3d3",
        transition: "all 0.3s ease",
        cursor: "pointer",
        "&:hover": {
          boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
          transform: "translateY(-4px)",
          border: "1px solid #bb1ccc",
        },
      }}
    >
      <Box>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 600, color, fontSize: "1.1rem" }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            height: "3px",
            width: "40px",
            backgroundColor: color,
            borderRadius: "2px",
            mt: 0.5,
          }}
        />
      </Box>

      <Typography
        variant="h4"
        sx={{ fontWeight: 700, color: "#3C3C3C", fontSize: "2rem" }}
      >
        {value.toLocaleString('en-US') }
      </Typography>
    </Box>
  );

  return (
    <div>
      <Box sx={{ display: "flex", gap: 4, mb: 2 }}>
        <SimpleStatCard
          title="Columns Analyzed"
          value={results?.length || 0}
          color="#bb1ccc"
        />
        <SimpleStatCard
          title="Rows Profiled"
          value={currentRowCount || "N/A"}
          color="#bb1ccc"
        />
      </Box>

      {results ? (
        <div>
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e0e0e0",
              borderRadius: "12px",
              marginTop: "20px",
              maxHeight: "500px",
              overflow: "auto",
            }}
          >
            <Table sx={{ minWidth: 650 }} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "16px 20px",
                      borderBottom: "2px solid #000080",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: "#bb1ccc !important",
                    }}
                  >
                    Column
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "16px 20px",
                      borderBottom: "2px solid #000080",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: "#bb1ccc !important",
                    }}
                  >
                    Data Type
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "16px 20px",
                      borderBottom: "2px solid #000080",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: "#bb1ccc !important",
                    }}
                  >
                    CDE
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "16px 20px",
                      borderBottom: "2px solid #000080",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: "#bb1ccc !important",
                    }}
                  >
                    Business Term
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "16px 20px",
                      borderBottom: "2px solid #000080",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: "#bb1ccc !important",
                    }}
                  >
                    Null %
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "16px 20px",
                      borderBottom: "2px solid #000080",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: "#bb1ccc !important",
                    }}
                  >
                    Statistics
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "16px 20px",
                      borderBottom: "2px solid #000080",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: "#bb1ccc !important",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {results ? (
                  results?.map((col, index) => (
                    <TableRow
                      key={col.column_name}
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:hover": {
                          backgroundColor: "#f0f8ff",
                          transition: "background-color 0.2s ease",
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          padding: "16px 20px",
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#2c3e50",
                        }}
                      >
                        {col.column_name}
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "16px 20px",
                          fontSize: "14px",
                          color: "#555",
                        }}
                      >
                        {col.type}
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "16px 20px",
                          fontSize: "14px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            px: 2,
                            py: 0.5,
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            backgroundColor: col.isCde ? "#e8f5e8" : "#fff3e0",
                            color: col.isCde ? "#2e7d32" : "#f57c00",
                          }}
                        >
                          {col.isCde ? "Yes" : "No"}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "16px 20px",
                          fontSize: "14px",
                          color: "#555",
                        }}
                      >
                        {col.businessterm === null ? "N/A" : col.businessterm}
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "16px 20px",
                          fontSize: "14px",
                          color: "#555",
                        }}
                      >
                        {col.nullPercentage === null
                          ? "N/A"
                          : `${col.nullPercentage || 0}%`}
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "16px 20px",
                          fontSize: "14px",
                          color: "#555",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <span>
                            <strong>Mean:</strong>{" "}
                            {col.mean === null ? "N/A" : col.mean}
                          </span>
                          <span>
                            <strong>Max:</strong>{" "}
                            {col.max === null ? "N/A" : col.max}
                          </span>
                          <span>
                            <strong>Min:</strong>{" "}
                            {col.min === null ? "N/A" : col.min}
                          </span>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "16px 20px",
                          fontSize: "14px",
                        }}
                      >
                        <Button
                          variant="text"
                          size="small"
                          sx={{
                            color: "#bb1ccc",
                            fontWeight: 600,
                            "&:hover": {
                              backgroundColor: "#f0f8ff",
                            },
                          }}
                          onClick={() => {
                            setGraphOpen(true);
                            setGraphColumn(col);
                          }}
                        >
                          View Plot
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      align="center"
                      sx={{
                        padding: "40px 20px",
                        fontSize: "16px",
                        color: "#666",
                        fontStyle: "italic",
                      }}
                    >
                      No profiling results found for the selected dataset.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Plotly Graph Popup  */}
          <Dialog
            open={graphOpen}
            onClose={() => setGraphOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <div className="flex justify-end items-center p-4">
              <IconButton onClick={() => setGraphOpen(false)}>
                <CloseIcon />
              </IconButton>
            </div>
            <DialogContent sx={{ p: 0 }}>
              <Plot
                data={graphColumn?.chart?.data || []}
                layout={{
                  ...(graphColumn?.chart?.layout || {}),
                  margin: {
                    t: 60,
                    b: 80,
                    ...(graphColumn?.chart?.layout?.margin || {}),
                  },
                  autosize: true,
                  width: null,
                  height: 500,
                }}
                style={{ width: "100%", height: "100%" }}
                useResizeHandler={true}
                config={{
                  displayModeBar: false,   // <-- hides the mode bar
                }}
              />
            </DialogContent>
          </Dialog>
        </div>
      ) : (
        <p>No result to display</p>
      )}
    </div>
  );
};
